import React from 'react';
import Proptypes from 'prop-types';
import { styled } from '@uhg-abyss/web/tools/styled';
import { useOnStepper } from '@src/state/stepper';
import { StepIndicator } from '@uhg-abyss/web/ui/StepIndicator';
import { useParams } from '@uhg-abyss/web/tools/reactRouterTools/reactRouterDom';
import { tokenizer } from '@uhg-abyss/web/tools/tokenizer';

const Container = styled('div', {
  margin: '0 auto 50px auto',
  width: '735px',
  paddingLeft: '0px',
  paddingRight: '40px',
  marginLeft: '-20px',
});

export const StepperV2 = ({ setActiveStep }) => {
  const { step: stepper, currentStep } = useOnStepper.state();
  const { token } = useParams();
  const parsedToken = tokenizer.parse(token);
  const isAPIMarketPlaceUser = parsedToken?.sourceSystem === 'apim';
  const currentStepNo =
    stepper?.find((el) => {
      return el.name === currentStep;
    })?.step || 1;
  if (!stepper || stepper.length === 0) return null;
  document.title = `${
    stepper.find((step) => {
      return currentStep === step.step || currentStep === step.name;
    })?.name || ''
  } | ${isAPIMarketPlaceUser ? ' API Marketplace' : ' UHC Provider Portal'}`;

  return (
    <Container>
      <StepIndicator
        barSize="5"
        variant="minimal"
        currentStep={currentStepNo}
        stepSize="15"
      >
        {stepper &&
          stepper.map((step) => {
            return (
              <StepIndicator.Step
                style={{
                  fontWeight: currentStepNo === step.step ? 'bold' : 'normal',
                }}
                label={step.name}
              />
            );
          })}
      </StepIndicator>
    </Container>
  );
};

StepperV2.propTypes = {
  setActiveStep: Proptypes.func.isRequired,
};
